import { ResourceHelperService } from "../resource-helper.service";

/**
 * A dataservice that provides operations for entitlement validations
 */
export class EntitlementValidationService {
  public entitlementValidationRequestResource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.EntitlementValidation.EntitlementValidationRequestResponse | InterACT.Interfaces.EntitlementValidation.EntitlementValidationRequestsResponse>>;
  private entitlementValidationRequestRetryActionResource: InterACT.Interfaces.IResource<InterACT.Interfaces.EntitlementValidation.ResourceLink>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.entitlementValidationRequestResource = $resource('api/entitlement-validation-requests');
    this.entitlementValidationRequestRetryActionResource = $resource('api/entitlement-validation-requests/:id/retry-action');
  }

    /**
   * Post an entitlement validation request retry action
   *
   * @param resourceLink the resourceLink containing the link to the entitlement validation request
   *
   * @returns A promise that resolves once the POST operation is complete
   */
    public createEntitlementValidationRequestRetryAction(entitlementValidationRequestId: string, resourceLink: InterACT.Interfaces.EntitlementValidation.ResourceLink) {
        return this.entitlementValidationRequestRetryActionResource.save({id: entitlementValidationRequestId}, resourceLink).$promise;
    }

    /**
   * Function to retrieve a list of entitlement validation requests
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.EntitlementValidation.EntitlementValidationRequestsResponse>>this.entitlementValidationRequestResource.get(options).$promise;
  }
}